import { generateHashing, signHash } from "../auth/hashing-service";
import { Bank } from "./Bank";
import PaymentService  from "../payment.service";
const baseUrl = process.env.REACT_APP_API_URL;

export class Bajio extends Bank {
    constructor(){
        super('bajio', 'post');
        this.url = `${baseUrl}/payment/request/bajio`
        this.concept = {
            "Factura": 1,
            "Anticipo":2,
            "Contado":3

        }
        this.paymentMethods = {
            post: this.startPostPayment.bind(this)
        }
    }
    
      hash(data){
        const messageWithHash = generateHashing(data)
        const messageSigned = signHash(messageWithHash)
        return messageSigned
    }
      /**
   * Comienza el servicio de almacenar pagos
   * Funcion que almacena pagos 
   * @author Kenzo Sashida - ETE
   * @version 1.0.0 - Diciembre 2024 -Servicio para almacenar pagos
   */
     async savePaymentRequest(data, an8){
            let dataPaymentContent = {
                account:"",
                product:"",
                order: data.an8?.trim(),
                reference: data.reference?.trim(),
                node:"",
                concept:data.paymentConcept,
                amount: data.amount > 0 ?Number.parseFloat(data.amount).toFixed(2).trim(): 0,
                singature:"",
                servicice:process.env.REACT_APP_CL_SERVICE, 
                customername: data.customerName,
                urlsuccess: baseUrl + process.env.REACT_APP_MP_URLSUCCESS,
                urlfailure: baseUrl + process.env.REACT_APP_MP_URLFAILURE,
            };
            try{
                const response = await PaymentService.savePaymentRequest(dataPaymentContent, an8)
                if(!response.data)throw new Error("Error al almacenar el pago.")
                return {success:"Ok"}
            }catch(err){
                return {error: err.message}
    
            }
        }
          /**
   * Servicio POST REST
   * Funcion que solicita url al servidor para redireccionar
   * @author Kenzo Sashida - ETE
   * @version 1.0.0 - Enero 2025 - Solicita al servidor url del banco
   */
     async startPostPayment(data){
        const amount =Number(data.amount) > 0 ? Number.parseFloat(data.amount).toFixed(2).trim() : 0.00;
        const dataToSend = {
            folio: data.an8,
            referencia:data.reference,
            monto:amount,
            concepto:data.paymentConcept,
            servicio:process.env.REACT_APP_CL_SERVICE,
            hash:""
        }
            try{
                const response = await PaymentService.startBajioPayment(dataToSend)
                window.open(response, "_blank").focus()
                return {success:"Ok"}

            }catch(err){
                return {error: err.message}
            }
          }
              /**
   * getFormFields
   * Funcion que genera los campos necesarios para enviar al banco
   * @author Kenzo Sashida - ETE
   * @version 1.0.0 - Enero 2025 - Enviar inputs establecidos por el banco
   */
     getFormFields(data) {
        return [
            {name:"cl_folio", value:data.an8?.trim()},
            {name:"cl_referencia", value: data.reference.trim()},
            {name:"dl_monto", value: data.amount, },
            {name:"servicio", value: process.env.REACT_APP_CL_SERVICE, },
            {name:"cl_concepto", value:data.paymentConcept,},
            {name:"hash", value:"", }
        ]
    }
}